function csrfToken() {
  const match = document.cookie.match(/csrftoken=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

async function ensureCsrf() {
  let token = csrfToken();
  if (token) return token;
  const response = await fetch('/api/auth/csrf/', { credentials: 'include' });
  const data = await response.json().catch(() => ({}));
  return data.csrfToken || csrfToken();
}

async function parseError(response) {
  const data = await response.json().catch(() => ({}));
  throw new Error(data.error || 'The assistant is unavailable right now.');
}

export async function listConversations() {
  const response = await fetch('/api/auth/chat/conversations/', { credentials: 'include' });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function getConversation(id) {
  const response = await fetch(`/api/auth/chat/conversations/${id}/`, { credentials: 'include' });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function createConversation({ content, files = [], projectId } = {}) {
  const token = await ensureCsrf();
  const body = new FormData();
  if (content) body.append('content', content);
  if (projectId) body.append('project_id', String(projectId));
  files.forEach((file) => body.append('files', file));
  const response = await fetch('/api/auth/chat/conversations/', {
    method: 'POST',
    credentials: 'include',
    headers: { 'X-CSRFToken': token },
    body,
  });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function sendConversationMessage(id, { content, files = [] } = {}) {
  const token = await ensureCsrf();
  const body = new FormData();
  if (content) body.append('content', content);
  files.forEach((file) => body.append('files', file));
  const response = await fetch(`/api/auth/chat/conversations/${id}/messages/`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'X-CSRFToken': token },
    body,
  });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function renameConversation(id, title) {
  const token = await ensureCsrf();
  const response = await fetch(`/api/auth/chat/conversations/${id}/`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': token,
    },
    body: JSON.stringify({ title }),
  });
  if (!response.ok) await parseError(response);
  return response.json();
}

export async function deleteConversation(id) {
  const token = await ensureCsrf();
  const response = await fetch(`/api/auth/chat/conversations/${id}/`, {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'X-CSRFToken': token },
  });
  if (!response.ok && response.status !== 204) await parseError(response);
}

export async function listProjects() {
  const response = await fetch('/api/public/projects/', { credentials: 'include' });
  if (!response.ok) return [];
  const data = await response.json().catch(() => []);
  return Array.isArray(data) ? data : [];
}
